import Box from 'components/shared/Box'
import { LegendBadgeGeneric, LegendBadgeCustom } from './styles'
import CalendarStarYellow from 'assets/images/calendar/star-calendar_yellow.svg'
import CalendarStarBlue from 'assets/images/calendar/star-calendar_blue.svg'
import CalendarStarBlueReversed from 'assets/images/calendar/star-calendar_blue-reversed.svg'
import CalendarStarYellowReversed from 'assets/images/calendar/star-calendar_yellow-reversed.svg'
import { useMemo } from 'react'

export type LegendBadgeType = 'highlight' | 'color' | 'icon'
export type LegendBadgeIconType = 'starBlue' | 'starYellow'

interface CalendarLegendBadgeProps {
    badge: LegendBadgeType
    badgeColor?: string
    badgeIcon?: LegendBadgeIconType
    hasDarkMode?: boolean
}

const CalendarLegendBadge = ({
    badge,
    badgeColor,
    badgeIcon,
    hasDarkMode,
}: CalendarLegendBadgeProps) => {
    const iconBadge = useMemo(() => {
        switch (badgeIcon) {
            case 'starBlue':
                return (
                    <Box mt={[2, 0]} minWidth={12}>
                        <img
                            src={
                                hasDarkMode
                                    ? CalendarStarBlueReversed
                                    : CalendarStarBlue
                            }
                            alt=""
                        />
                    </Box>
                )
            case 'starYellow':
                return (
                    <Box mt={[2, 0]} minWidth={12}>
                        <img
                            src={
                                hasDarkMode
                                    ? CalendarStarYellowReversed
                                    : CalendarStarYellow
                            }
                            alt=""
                        />
                    </Box>
                )
            default:
                return null
        }
    }, [badgeIcon, hasDarkMode])

    const calculatedBadge = useMemo(() => {
        switch (badge) {
            case 'highlight':
                return (
                    <Box mt={[2, 0]} minWidth={12}>
                        <LegendBadgeGeneric />
                    </Box>
                )
            case 'color':
                return badgeColor ? (
                    <LegendBadgeCustom
                        color={badgeColor}
                        mt={[2, 0]}
                        minWidth={12}
                        hasDarkMode={hasDarkMode}
                    />
                ) : null
            case 'icon':
                return iconBadge
            default:
                return null
        }
    }, [badge, badgeColor, hasDarkMode])

    return calculatedBadge
}

export default CalendarLegendBadge
